import React, { useState, useEffect,useCallback } from 'react'
import {  useParams} from 'react-router-dom';
import { format } from 'date-fns'

import AuthStore from '../../../stores/AuthStore';
import PlanActions from '../../../actions/PlanActions';
import PlanStore from '../../../stores/PlanStore';
import ErrorStore from '../../../stores/ErrorStore';
import PlanItem from "../parts/PlanItem"
import MessageBox from '../parts/MessageBox'
import Alert from "../parts/Alert"
import Menu from '../parts/Menu';
import Header from '../parts/Header';


function PlanListApp(props:PropsValue) {

  const { accommodation_id } = useParams();

  const [list, setList] = useState(null)
  const [detail, setDetail] = useState(null)
  const [pannelCss, setPannelCss] = useState("full")

  const [alert, setAlert] = useState(null)

  const [boxError, setBoxError] = useState(0)
  const [boxMessage, setBoxMessage] = useState("")
  const [boxClass, setBoxClass] = useState("")

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stablePlanChangeHandler = useCallback(planChangeHandler, [])
  const stablePlanCreatedHandler = useCallback(planCreatedHandler,[])
  const stablePlanDeletedHandler = useCallback(planDeletedHandler,[])
  const stableErrorChangeHandler = useCallback(errorChangeHandler, [])


  useEffect(() => {
    PlanStore.addChangeListener(stablePlanChangeHandler)
    PlanStore.addChangeListener(stablePlanCreatedHandler, "created")
    PlanStore.addChangeListener(stablePlanDeletedHandler, "deleted")
    ErrorStore.addChangeListener(stableErrorChangeHandler)
    PlanActions.getList(AuthStore.getToken(),accommodation_id)
    return function cleanup() {
      PlanStore.removeChangeListener(stablePlanChangeHandler)
      ErrorStore.removeChangeListener(stableErrorChangeHandler)
      PlanStore.removeChangeListener(stablePlanCreatedHandler, "created")
      PlanStore.removeChangeListener(stablePlanDeletedHandler, "deleted")
    };

  },[stablePlanChangeHandler,stablePlanCreatedHandler,stablePlanDeletedHandler,stableErrorChangeHandler,accommodation_id]);


  function errorChangeHandler(){
    setBoxError(1)
    setBoxMessage(ErrorStore.getMessage())
    setBoxClass("active")
  }

  function planCreatedHandler(){
    setBoxError(0)
    setBoxMessage("プランが作成されました。")
    setBoxClass("active")
    setPannelCss("full")
    setDetail(null)
  }
  function planDeletedHandler(){
    setBoxError(0)
    setBoxMessage("プランが削除されました。")
    setBoxClass("active")
  }


  function planChangeHandler(){

    setList(PlanStore.getList().map( item => {
      return <div className="mail-list-item" key={"plan_list_" + item.id}>
          <div className="name">{item.name}</div>
          <div className="date">{format(new Date(item.start_at), 'yyyy年MM月dd日')}</div>
          <div className="date">{format(new Date(item.end_at), 'yyyy年MM月dd日')}</div>
          <div  className="d100 center">{item.is_active === 1  ? "掲載" : "非掲載"}</div>
          <div className="button wide-hidden">{item.ikyu_id ? <a href={"/m/accommodation/" + accommodation_id + "/plan/"  + item.id + "/sync/check"} >同期確認</a> : null}</div>
          <div className="button wide-hidden" onClick={() => openPannel(item.id)}>設定</div>
          <div className="button wide-hidden"><a href={"/m/accommodation/" + accommodation_id + "/plan/"  + item.id + "/price"} >金額設定</a></div>
          <div className="button wide-hidden" onClick={() => deleteItem(item.id)}>削除</div>
        </div>
    }))
  }


  function openPannel(id){
    setPannelCss("wide")
    setDetail(<PlanItem id={id} accommodation_id={accommodation_id} closePannel={closePannel} />)
  }

  function closePannel(){
    setPannelCss("full")
    setDetail(null)
  }

  function createNew(){
    setPannelCss("wide")
    setDetail(<PlanItem id={0} accommodation_id={accommodation_id} closePannel={closePannel} />)
  }

  function deleteItem(id){
    setAlert(<Alert ok="削除"  message="プランを削除してよろしいですか" executor={deleteExe} cancell={cancell} param={id}/>)
  }

  function cancell(){
    setAlert(null)
  }

  function deleteExe(id){
    setAlert(null)
    PlanActions.delete(AuthStore.getToken(), accommodation_id, id)
  }



  function closeMessageBox(){
    setBoxClass("close")
  }

  return(
    <div className="inner">
        <main className="main">
          <Menu selected="accommodation" accommodation_id={accommodation_id} />
          <div className="main-content calendar">
            <Header accommodation_id = {accommodation_id} id="calendar"/>

            <div className="free-pannel scrollable-vertical">
              <section className={"pannel " + pannelCss}>
                <div className="section-header">
                  <div className="title">プラン一覧</div>
                  <div className="right-menu">
                    <div className="inline-link" onClick={createNew}><i className="fas fa-plus-circle"></i> 新規プラン作成</div>
                  </div>
                </div>

                <div className="mail-list-item header">
                  <div className="name">プラン名</div>
                  <div  className="date">開始日</div>
                  <div  className="date">終了日</div>
                  <div  className="d100">掲載</div>
                  <div  className="button wide-hidden">同期</div>
                  <div  className="button wide-hidden">設定</div>
                  <div  className="button wide-hidden">金額設定</div>
                  <div  className="button wide-hidden">削除</div>
                </div>

                <div className="scrollable-container">
                  <div className="scrollable-vertical">{list}</div>
                </div>


              </section>
            </div>
          </div>
          {detail}
          {alert}
          <MessageBox message={boxMessage} error={boxError} main_class={boxClass} closeMessageBox={closeMessageBox}/>
        </main>
    </div>
  )
}

export default PlanListApp
